var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalenderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.200195,
    width: 39.6001,
    height: 39.6001,
    rx: 5.2,
    fill: "#EBDFFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.2506 9.9H25.7756V9.075C25.7756 8.8562 25.6887 8.64636 25.534 8.49164C25.3793 8.33692 25.1694 8.25 24.9506 8.25C24.7318 8.25 24.522 8.33692 24.3673 8.49164C24.2125 8.64636 24.1256 8.8562 24.1256 9.075V9.9H15.8756V9.075C15.8756 8.8562 15.7887 8.64636 15.634 8.49164C15.4792 8.33692 15.2694 8.25 15.0506 8.25C14.8318 8.25 14.622 8.33692 14.4672 8.49164C14.3125 8.64636 14.2256 8.8562 14.2256 9.075V9.9H11.7506C11.313 9.9 10.8933 10.0738 10.5839 10.3833C10.2744 10.6927 10.1006 11.1124 10.1006 11.55V28.05C10.1006 28.4877 10.2744 28.9073 10.5839 29.2168C10.8933 29.5262 11.313 29.7001 11.7506 29.7001H28.2506C28.6882 29.7001 29.1079 29.5262 29.4174 29.2168C29.7268 28.9073 29.9006 28.4877 29.9006 28.05V11.55C29.9006 11.1124 29.7268 10.6927 29.4174 10.3833C29.1079 10.0738 28.6882 9.9 28.2506 9.9ZM28.2506 14.85H11.7506V11.55H14.2256V12.375C14.2256 12.5938 14.3125 12.8037 14.4672 12.9584C14.622 13.1131 14.8318 13.2 15.0506 13.2C15.2694 13.2 15.4792 13.1131 15.634 12.9584C15.7887 12.8037 15.8756 12.5938 15.8756 12.375V11.55H24.1256V12.375C24.1256 12.5938 24.2125 12.8037 24.3673 12.9584C24.522 13.1131 24.7318 13.2 24.9506 13.2C25.1694 13.2 25.3793 13.1131 25.534 12.9584C25.6887 12.8037 25.7756 12.5938 25.7756 12.375V11.55H28.2506V14.85Z",
    fill: "#6000E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderIcon);
export default __webpack_public_path__ + "static/media/calender-icon.308a7e515ff414e4fd2216d62d262c0e.svg";
export { ForwardRef as ReactComponent };